import React from "react";
import { node } from "prop-types";
import { Col, Container, Row } from "../Grid";
import Section from "../Section";

const UpdatesPageTemplate = ({ children }) => (
	<Section className="updates-page-template">
		<Container>
			<Row px utility={{ justify: "center" }}>
				<Col sm={12} md={11} lg={8}>
					{children}
				</Col>
			</Row>
		</Container>
	</Section>
);

UpdatesPageTemplate.propTypes = {
	children: node.isRequired,
};

export default UpdatesPageTemplate;
